<h1 matDialogTitle>{{'CONFIRM_DIALOG.confirm' |translate}}</h1>
<div mat-dialog-content>{{confirmMessage}}</div>
<div mat-dialog-actions class="pt-24">
    <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">{{'CONFIRM_DIALOG.confirm' |translate}}</button>
    <button mat-button (click)="dialogRef.close(false)">{{'CONFIRM_DIALOG.cancel' |translate}}</button>
</div>
